import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { columnsDailyData, listDataDailyData } from "./data/Daily";
import { columnsMonthlyData, listDataMonthlyData } from "./data/Monthly";

import BootstrapTable from "react-bootstrap-table-next";
import { DatePicker } from "antd";
import Flatpickr from "react-flatpickr";
import FlowFuelOilDaily from "./tab/FlowFuelOilDaily";
import FlowFuelOilMonthly from "./tab/FlowFuelOilMonthly";
import PropTypes from "prop-types";
import Select from "react-select";
import cellEditFactory from "react-bootstrap-table2-editor";
import classnames from "classnames";
import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";

// import OverButton from "../../components/Custom/Overbutton";

const generateYearList = () => {
  const currentYear = new Date().getFullYear();
  let years = [];
  for (let index = currentYear - 4; index <= currentYear; index++) {
    years.push({ label: index, value: index });
  }
  return years;
};
function disabledDate(current) {
  // Can not select days before today and today
  return current && current > moment().endOf('day');
}
//i18n
function Flow_Fueloli(props) {
  const [dateSelected, setDateSelected] = useState(moment().add(-1, 'day').toDate());
  const [activeTab, setActiveTab] = useState("2");
  const [listYear, setListYear] = useState(generateYearList());
  const [pageDataConfirmModal, dataConfirmModal] = useState(false);

  const [yearSelected, setYearSelected] = useState({
    label: new Date().getFullYear(),
    value: new Date().getFullYear(),
  });

  // Handle Set Value DropDown Search //
  const handleYearSelected = selected => {
    setYearSelected(selected);
  };

  //sort Column//
  const defaultSorted = [
    {
      dataField: "Id",
      order: "asc",
    },
  ];

  // const RowStyleFontWhite = (row, rowIndex) => {
  //   const style = {};
  //   // style.fontWeight = 'bold';
  //   style.color = "white";

  //   if (row.Id == 18) {
  //     style.backgroundColor = "#c8e6c9";
  //   } else {
  //     // style.backgroundColor = "#00BFFF";
  //   }

  //   return style;
  // };

  //headerColumn
  // const addHeaderTable1 = () => {
  //   let thead = document
  //     .getElementById("flow-selection-table-1")
  //     .getElementsByTagName("thead")[0];
  //   let tr = document.createElement("tr");
  //   tr.innerHTML =
  //     '</th><th colspan="17" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Monthly</th>';
  //   thead.prepend(tr);
  // };

  // const addHeaderTable2 = () => {
  //   let thead = document
  //     .getElementById("flow-selection-table-2")
  //     .getElementsByTagName("thead")[0];
  //   let tr = document.createElement("tr");
  //   tr.innerHTML =
  //     '</th><th colspan="17" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Daily</th>';
  //   thead.prepend(tr);
  // };

  //onInit//
  useEffect(function () {
    // addHeaderTable1();
    // addHeaderTable2();
  }, []);
  //onInit//

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              {/* <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Flow/Fuel Oli ( Monthly & Daily )")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Manual Data Entry
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Flow/Fuel Oli ( Monthly & Daily )
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card> */}

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                          <Row>
                            <Col sm="12">
                              <FormGroup className="row">
                                <Col
                                  sm={9}
                                  className=" d-flex align-items-center justify-content-end"
                                >
                                  <h5> Data Year :</h5>
                                </Col>
                                <Col>
                                  <Select
                                    placeholder="Select Date"
                                    value={yearSelected}
                                    onChange={handleYearSelected}
                                    options={listYear}
                                    classNamePrefix="select2-selection"
                                  />
                                </Col>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row className="mt-4">
                            <hr />
                          </Row>
                        </TabPane>
                      </TabContent>

                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="2">
                          <Row>
                            <Col sm="12">
                              <FormGroup className="row">
                                <div className=" d-flex align-items-center justify-content-end">
                                  <h5> Data Month : </h5>
                                  <DatePicker
                                    style={{ width: 200, marginLeft: 20 }}
                                    defaultValue={moment(dateSelected)}
                                    format={"MMMM YYYY"}
                                    onChange={(date, dateString) => {
                                      if (date != null) {
                                        setDateSelected(date.toDate());
                                      }
                                    }}
                                    picker="month"
                                    disabledDate={disabledDate}
                                  />
                                </div>
                                {/* <Col
                                  sm={9}
                                  className=" d-flex align-items-center justify-content-end"
                                >
                                  <h5> Data Date :</h5>
                                </Col>
                                <Col
                                  sm={3}
                                  className="d-flex align-items-center justify-content-start"
                                >
                                  <Flatpickr
                                    className="form-control d-block"
                                    placeholder="Select Date"
                                    options={{
                                      altInput: true,
                                      // altFormat: "d/m/Y",
                                      altFormat: "F Y",
                                      dateFormat: "d/m/Y",
                                      maxDate: new Date(),
                                    }}
                                    onChange={value =>
                                      setDateSelected(...value)
                                    }
                                    value={dateSelected}
                                  />
                                </Col> */}
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row className="mt-4">
                            <hr />
                          </Row>
                        </TabPane>
                      </TabContent>

                      <Row>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                setActiveTab("2");
                                // dataConfirmModal(true);
                              }}
                            >
                              Flow/Fuel ( Daily )
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                                // dataConfirmModal(true);
                              }}
                            >
                              Flow/Fuel ( Monthly )
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row>

                      <Row>
                        <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          <TabPane tabId="1">
                            {/* <Col sm="12">
                              <div>
                                <BootstrapTable
                                  id="flow-selection-table-1"
                                  keyField="Id"
                                  data={listDataMonthlyData}
                                  columns={columnsMonthlyData}
                                  headerClasses="header-style"
                                  // rowStyle={RowStyleFontWhite}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  hover
                                />
                              </div>
                            </Col> */}
                            <FlowFuelOilMonthly
                              yearSelected={yearSelected.value}
                            />
                          </TabPane>

                          <TabPane tabId="2">
                            {/* <Col sm="12">
                              <div>
                                <BootstrapTable
                                  id="flow-selection-table-2"
                                  keyField="Id"
                                  data={listDataDailyData}
                                  columns={columnsDailyData}
                                  headerClasses="header-style"
                                  // rowStyle={RowStyleFontWhite}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  hover
                                />
                              </div>
                            </Col> */}
                            <FlowFuelOilDaily dateSelected={dateSelected} />
                          </TabPane>
                        </TabContent>
                      </Row>

                      {/* <hr /> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>

            {/*start : DataConfirmModal */}
            <Modal size="lg" isOpen={pageDataConfirmModal}>
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                  Confirm
                </h5>
              </div>
              <div className="modal-body p-0">
                <CardBody className="p-3">
                  <Form>
                    <Row>
                      <div className="modal-body text-center p-0">
                        <h4>มีการเปลี่ยนข้อมูลในตาราง</h4>
                        <br />
                        <h4>คุณต้องการบันทึกการเปลี่ยนแปลงหรือไม่ ?</h4>
                      </div>
                    </Row>
                  </Form>
                </CardBody>
                <div className="modal-footer">
                  <button type="button" className="btn btn-success me-2">
                    <i className="fas fa-check"></i>&nbsp; Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => dataConfirmModal(false)}
                  >
                    <i className="fas fa-times fa-lg"></i>&nbsp; Cancel
                  </button>
                </div>
              </div>
            </Modal>
            {/*end : PageAdd */}
          </Row>
        </Container>
      </div>

      {/*end : PageAdd */}
    </React.Fragment>
  );
}

Flow_Fueloli.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ Flow_Fueloli }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Flow_Fueloli));
